import { useAppDispatch, useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import { MOBILE_ORDER_DISPLAY_ONLY_EDITED } from 'features/Store/constants';
import { COLUMN_WIDTH } from 'features/Store/pages/StoreSettingDetailPage';
import { selectStoreSettingDetailDisplayType, storeSettingDetailActions } from 'features/Store/storeSettingDetailSlice';
import {
  countMultiplePosCodeRegisteredOnChildSubMenu,
  getDefaultMobileOrderDisplayFlg,
  hasEditedMobileOrderDisplayFlg,
} from 'features/Store/utils';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { MINUS_TEXT } from 'utils';
import {
  ChildSubMenu,
  ChildSubMenuGroup,
  Course,
  Genre,
  Menu,
  MenuBook,
  MenuDetail,
  SubGenre,
  SubMenu,
  SubMenuGroup,
} from '../../models';
import MobileOrderDisplayModal from '../MobileOrderDisplayModal';

export interface ChildSubMenuRowCollapseProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
  menu: Menu;
  subMenuGroup: SubMenuGroup;
  subMenu: SubMenu;
  childSubMenuGroup: ChildSubMenuGroup;
  childSubMenu: ChildSubMenu;
  children?: React.ReactNode;
}

interface MobileOrderDisplayModalData {
  posCodeId: number;
  posCode: string;
  restaurantId: number;
  menuName: string;
  menuCode: string;
  couponClassification: number;
  defaultMobileOrderDisplayFlg: boolean;
}

function ChildSubMenuRow({
  menuBook,
  course,
  genre,
  subgenre,
  menu,
  subMenuGroup,
  subMenu,
  childSubMenuGroup,
  childSubMenu,
  children,
}: ChildSubMenuRowCollapseProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { restaurantId } = useParams<{ restaurantId: string }>();

  // selector
  // const editedMenuBookIds = useAppSelector(selectStoreSettingEditedMenuBookIds);
  const displayType = useAppSelector(selectStoreSettingDetailDisplayType);
  // const isExpand = useAppSelector(selectStoreSettingDetailExpandAll);

  // state
  // const [open, setOpen] = useState(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));

  const [showMobileOrderDisplayModal, setShowMobileOrderDisplayModal] = useState(false);
  const [mobileOrderDisplayModalData, setMobileOrderDisplayModalData] = useState<MobileOrderDisplayModalData>();

  let pathId = `${menuBook.id}-${genre.id}-${subgenre.id}-${menu.id}-${subMenuGroup.id}-${subMenu.id}-${childSubMenuGroup.id}-${childSubMenu.id}`;
  if (course) {
    pathId = `${menuBook.id}-${course.id}-${genre.id}-${subgenre.id}-${menu.id}-${subMenuGroup.id}-${subMenu.id}-${childSubMenuGroup.id}-${childSubMenu.id}`;
  }

  // useEffect(() => {
  //   const btnExpandElem = document.querySelector(`#childsubmenu-${pathId}-row .dan-btn-expand`) as HTMLButtonElement;
  //   function handleBtnExpandElemClick(event: MouseEvent) {
  //     event.stopPropagation();
  //     setOpen(!open);
  //     dispatch(storeSettingDetailActions.setExpandAll(undefined));
  //     btnExpandElem.innerHTML = !open ? MINUS_TEXT : PLUS_TEXT;
  //     btnExpandElem?.setAttribute('aria-expanded', !open ? 'true' : 'false');
  //   }

  //   if (btnExpandElem) {
  //     btnExpandElem.addEventListener('click', handleBtnExpandElemClick);
  //   }

  //   return () => {
  //     if (btnExpandElem) {
  //       btnExpandElem.removeEventListener('click', handleBtnExpandElemClick);
  //     }
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [open, displayType]);

  // useEffect(() => {
  //   if (isExpand !== undefined) {
  //     setOpen(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isExpand]);

  const assingedMenuDetailList = childSubMenu.menu_details.filter(
    (menuDetail) => menuDetail.counter_pattern_display_flg !== null
  );

  const hasEdited = hasEditedMobileOrderDisplayFlg(assingedMenuDetailList[0]);
  const defaultMobileOrderDisplayFlg = getDefaultMobileOrderDisplayFlg(assingedMenuDetailList[0]);
  const numberofMulitpleRegisteredPosCode = countMultiplePosCodeRegisteredOnChildSubMenu(childSubMenu);

  function handleCloseMobileOrderDisplayModal(isDataChanged: boolean = false) {
    if (isDataChanged) {
      dispatch(storeSettingDetailActions.reloadData());
    }

    setShowMobileOrderDisplayModal(false);
    setMobileOrderDisplayModalData(undefined);
  }

  function handleOpenMobileOrderDisplayModal(menuDetail?: MenuDetail) {
    if (menuDetail) {
      const currentDefaultMobileOrderDisplayFlg = getDefaultMobileOrderDisplayFlg(menuDetail);
      setShowMobileOrderDisplayModal(true);
      setMobileOrderDisplayModalData({
        posCodeId: menuDetail.pos_code_id,
        posCode: menuDetail.pos_code_cd,
        restaurantId: Number(restaurantId) || 0,
        menuName: childSubMenu.name,
        menuCode: childSubMenu.cd,
        couponClassification: childSubMenu.coupon_classification,
        defaultMobileOrderDisplayFlg: currentDefaultMobileOrderDisplayFlg || false,
      });
    }
  }

  if (displayType === MOBILE_ORDER_DISPLAY_ONLY_EDITED && !hasEdited) {
    return null;
  }

  return (
    <>
      <div
        id={`childsubmenu-${pathId}-row`}
        className={`c-childsubmenu-row dan-tr content-visibility-auto ${hasEdited ? 'has-edited' : ''}`}
      >
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(0, 14).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
        <div className="dan-td" style={{ width: `${COLUMN_WIDTH[14]}%` }}>
          <button
            className="dan-btn-expand"
            tabIndex={-1}
            aria-controls={`childsubmenu-${pathId}-content`}
            aria-expanded={false}
          >
            {MINUS_TEXT}
          </button>
          <span>{childSubMenu.name}</span>
        </div>
        <div className="dan-td justify-content-center" style={{ width: `${COLUMN_WIDTH[15]}%` }}>
          {numberofMulitpleRegisteredPosCode === 0 ? (
            <span className="not-apply">{t('StoreSettingDetailPage.not_apply')}</span>
          ) : (
            <span>{assingedMenuDetailList[0] && Number(assingedMenuDetailList[0].pos_code_cd)}</span>
          )}
        </div>
        <div className="dan-td justify-content-center" style={{ width: `${COLUMN_WIDTH[16]}%` }}>
          {defaultMobileOrderDisplayFlg === undefined ? null : (
            <Button
              className={clsx('btn-edit-mobile-display-flg', {
                'btn--dark-green': defaultMobileOrderDisplayFlg,
                'btn--green': !defaultMobileOrderDisplayFlg,
              })}
              onClick={handleOpenMobileOrderDisplayModal.bind(null, assingedMenuDetailList[0])}
            >
              {defaultMobileOrderDisplayFlg ? t('StoreSettingDetailPage.enable') : t('StoreSettingDetailPage.disable')}
            </Button>
          )}
        </div>
      </div>
      {assingedMenuDetailList.map(function (menuDetail, index) {
        if (index === 0) {
          return null;
        }

        const hasEdited = hasEditedMobileOrderDisplayFlg(menuDetail);
        const otherDefaultMobileOrderDisplayFlg = getDefaultMobileOrderDisplayFlg(menuDetail);

        if (displayType === MOBILE_ORDER_DISPLAY_ONLY_EDITED && !hasEdited) {
          return null;
        }

        return (
          <div
            key={index}
            id={`childsubmenu-${pathId}-detail-row-${index}`}
            className={`c-childsubmenu-row dan-tr ${hasEdited ? 'has-edited' : ''}`}
          >
            <div
              className="dan-td"
              style={{
                width: `${COLUMN_WIDTH.slice(0, 14).reduce((sum, width) => sum + width, 0)}%`,
              }}
            ></div>
            <div className="dan-td" style={{ width: `${COLUMN_WIDTH[14]}%` }}></div>
            <div className="dan-td justify-content-center" style={{ width: `${COLUMN_WIDTH[15]}%` }}>
              {menuDetail.counter_pattern_display_flg === null ? (
                <span className="not-apply">{t('StoreSettingDetailPage.not_apply')}</span>
              ) : (
                <span>{Number(menuDetail.pos_code_cd)}</span>
              )}
            </div>
            <div className="dan-td justify-content-center" style={{ width: `${COLUMN_WIDTH[16]}%` }}>
              {otherDefaultMobileOrderDisplayFlg === undefined ? null : (
                <Button
                  className={clsx('btn-edit-mobile-display-flg', {
                    'btn--dark-green': otherDefaultMobileOrderDisplayFlg,
                    'btn--green': !otherDefaultMobileOrderDisplayFlg,
                  })}
                  onClick={handleOpenMobileOrderDisplayModal.bind(null, menuDetail)}
                >
                  {otherDefaultMobileOrderDisplayFlg
                    ? t('StoreSettingDetailPage.enable')
                    : t('StoreSettingDetailPage.disable')}
                </Button>
              )}
            </div>
          </div>
        );
      })}

      {/* <div style={{ contentVisibility: open ? 'auto' : 'hidden' }}>
        <div id={`childsubmenu-${pathId}-content`}>{children}</div>
      </div> */}

      {showMobileOrderDisplayModal &&
        mobileOrderDisplayModalData &&
        createPortal(
          <MobileOrderDisplayModal
            posCodeId={mobileOrderDisplayModalData.posCodeId}
            posCode={mobileOrderDisplayModalData.posCode}
            restaurantId={mobileOrderDisplayModalData.restaurantId}
            menuName={mobileOrderDisplayModalData.menuName}
            menuCode={mobileOrderDisplayModalData.menuCode}
            couponClassification={mobileOrderDisplayModalData.couponClassification}
            defaultMobileOrderDisplayFlg={mobileOrderDisplayModalData.defaultMobileOrderDisplayFlg}
            onClose={handleCloseMobileOrderDisplayModal}
          />,
          document.body
        )}
    </>
  );
}

export default ChildSubMenuRow;
